// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__3Qqba","imgcontainer":"card_imgcontainer__zYtxp","img":"card_img__20XUd","info":"card_info__2D5di","short":"card_short__1qIpQ","long":"card_long__1Zsex"};